module.exports = __webpack_public_path__ + "img/search-icon2.e6c59275.svg";